namespace('arctic.views.group');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');

compass.require('compass.group.GroupFormsWidget');

compass.require('compass.util.validate');

arctic.views.group.groupInfo = function (viewport,options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('groupInfoView');
	/***
	 * Group contact info page view
	 *
	 * Has the fields for group name, group lead contact info
	 * the credit card, password, stay info
	 */
	var _viewport = viewport;
	var $j = jQuery;
	var d = jQuery.dom;
	// Widgets are stored in an object, keeps them together and saves namespace
	var widgets = {};

	var _settings = options;
	var _data;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
			_checkWholeForm();
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var _str2date = function (src) {
		src = src.split("-");
		return new Date(parseInt(src[0], 10), parseInt(src[1], 10),
				parseInt(src[2], 10), 0, 0, 0, 0);
	};

	var groupInfo;
	var _jsonData;



	// checks to see this was instaniated with a new prefix, if it wasn't all of the 'this' keywords point to window
	if (!(this instanceof arctic.views.group.groupInfo)) {
		throw "Need to instaniate this object with a \"new\" prefix.";
	}
	var me = this;
	var _meeting;
	var _details;
	var _hotel;

	var	URL = {
			submit : "/actGroupInfo",
			request : "/getGroupInfo"
		};

	var render = function (d) {
		_viewport.append(d.div({ className : 'groupInfo' },
			d.div({ className : 'reservationRecap' }),
			d.div({ className : 'separator'}),
			d.div({ className: 'groupFormsContainer' }),
			d.div({ className : 'stayRecap' })
		));
	};

	var _showPoliciesPopup = function(data) {
		jQuery.ajax({
			data: {
				blocked_room_id: _jsonData.blockRoomId
			},
			dataType:'json',
			traditional: true,
			url:'/policies',
			success : function(data) {
				var d = jQuery.dom;
				var policiesDiv = d.div({className:'policiesContainer'});

				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv,
					{
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	};

	var _invalid_fields = [];

	var makeWidget = function (params) {
		/***
		 * This is a space saving function, generates the widget passed in as /params.widget/
		 * and saves it under the alias in /params.name/ in the /widgets/ object and renders it
		 * in the DOM object with the idea also from /params.name/ (could be changed later).
		 */
		var name = params.name;
		var widget = params.widget;
		var settings = typeof params.settings === 'object' ? params.settings : {};

		settings.WUID = 'groupView_' + name;

		widgets[name] = new widget(
				viewport.find("." + name), settings);
	};
	
	var getReservationData = function() {		
		if(_jsonData.reservations.length > 0) {
			return {
				"iterations": _settings.iterations,
				"reservations": _.map(_jsonData.reservations, function(res) { 
					return {
						"blocked_room_id": _jsonData.blockRoomId[0],
						"arrive": res.stayRecap.checkIn,
						"depart": res.stayRecap.checkOut,
						"rooms": res.stayRecap.numRooms
					};
				})
			};
		} else {
			return {};
		}
	};

	var onFormSubmit = function(formData, finishLoading) {
		$j.ajax({
			url: URL.submit,
			data : JSON.stringify(formData),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			error: function (data) {
				button.prop("disabled", false);
				alert ('Problem creating record.');
			},
			success: function (data) {
				if (data.noResError) {
					_existingHousingAlert = d.alert("Looks like you just made a similar reservation request. You will be directed to your group details.");
					jQuery('.alertCloseButton').click(function(){
						jQuery('.forms').trigger(CompassEvents.Navigate, 'frontDesk');
					});
				}
				else if(!data.loginInfo.loggedIn){
					if (data.policiesCheckboxChecked === false) {
						d.alert("Please agree to the hotel policies before continuing.");
					} else {
						// currently this means that the backend password strength/length check did not pass
						alert ('Problem creating record.');
					}
				}
				else {
					if (data.loginInfo.soldOut === false){
						var estimatedTotal = widgets['stayRecap'].getEstimatedTotalValue();
						compass.util.tracking.googleConversion({
							value: estimatedTotal,
							currency: _settings.meetingInfo.currencyCode
						});
						$j('body').css({cursor : 'inherit'});
						$j('body').trigger(CompassEvents.Login, data.loginInfo);
						$j('.forms').trigger(CompassEvents.Navigate, 'groupManage');
						var estimatedTotal = widgets['stayRecap'].getEstimatedTotalValue();
						compass.trackEvent('ReservationCreated', getReservationData()); //Keen Tracking
						compass.GA.trackEvent('Group', 'ReservationCreated');
						compass.trackFbPixelEvent('Purchase', {value:estimatedTotal,currency:_settings.meetingInfo.currencyCode});
					}
					else{
						compass.trackEvent('RaceConditionAlert');
						_soldOutAlert = d.alert("Another user booked the last available rooms while you were entering your details. We’re sorry! Unfortunately, this means you’ll need to restart your search (but we’ve saved your info so you won’t have to key it in again).");
						jQuery('.alertCloseButton').click(function(){
							$j('.forms').trigger(CompassEvents.Navigate, 'hotels');
						});
					}
				}
				finishLoading();
			}
		});
	};

	var setup = function (data) {
		/***
		 * Runs through the widgets that need to be setup and generates them, storing them
		 * in the /widgets/ object
		 */
		_jsonData = data;
		meeting = data.meeting;
		_hotel = data.hotel;
		var recapArray = data.reservations;

		var reservationArray = _.pluck(recapArray, 'stayRecap');

		var recaps = _.filter(reservationArray, function(e,i){
																return e.depositWillBeCharged;
							   });
		var	chargingInfo = {
				hasCharging : _.some(reservationArray, function(r){return (r.depositWillBeCharged);}),
				chargingToday : _.some(reservationArray, function(r){
																		return (r.depositWillBeCharged && r.depositWillBeChargedTodayOrEarlier);
																	}),
				chargingFirstDate : recaps.length > 0 ? compass.util.parse.ISODateParser(_.min(recaps,function(e){ return Number(e.depositWillBeChargedAt.split('-').join(''));}).depositWillBeChargedAt) : '',
				hasServiceFees : _.some(reservationArray, function (stayRecap) { return Number(stayRecap.serviceFeeAmount) > 0; })
		};


		makeWidget({ name: "groupFormsContainer", widget: compass.group.GroupFormsWidget,
			settings: {
				blockRoomId: data.blockRoomId,
				countriesAndStates: _settings.countriesAndStates,
				extraRequiredFields: data.extraRequiredFields,
				groupInfo: data.groupInfo,
				paymentOptions: data.paymentOptions,
				reservations: data.reservations,
				validator: _validator,
				meetingInfo: _settings.meetingInfo,
				onFormSubmit: onFormSubmit,
				chargingInfo: chargingInfo,
				editablePrefill: _settings.regData
			}});

		_viewport.find(".policiesLink").activate(function(){
				compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Group Info - Agree Link');
				_showPoliciesPopup(data);
		});

		makeWidget({ name: "stayRecap", widget: compass.hotel.StayRecapWidget,
			settings: {
				recapArray : recapArray,
				//totals: totals,
				validator: _validator,
				meetingInfo: _settings.meetingInfo,
				groupInfo: groupInfo,
				rooms: data.reservations.length,
				chargingInfo: data.chargingInfo
			}});

		_viewport.find(".stayRecap").bind('StayRecapWidget.showPolicies', function () {
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Group Info - Receipt');
			_showPoliciesPopup(data);
		});

		_viewport.find(".stayRecap").append(d.div({className : 'stayRecapShadow'}));

		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});		
	};

	var _checkWholeForm = function() {
		_validation_res = _validator.validate();

		if (_validation_res.length === 0) {
			var button = _viewport.find(".saveButton");
			button.removeClass('disabled');
		}
	};

	this.run = function (renderComplete) {
		compass.loading.start();

		$j.ajax({
			url: URL.request,
			success: function (data) {
				_settings.iterations = data.iterations || 1;
				_settings.countriesAndStates = data.countriesAndStates;
				_data = data;
				if(data.groupInfo)groupInfo = data.groupInfo;
				//_returningGroup = _data'groupInfo'] != null);


				if (data.error) {
					_viewport.trigger(CompassEvents.Navigate, 'groupManage');
				} else {
					render(jQuery.dom);
					setup(data);
				}
				compass.loading.stop();
				// stops measuring the time it takes the view to load
				compass.stopLoad('groupInfoView');
				renderComplete();
			}
		});
	};

};
